<!-- ヘッダー -->
<div class="header">
  <div class="header-content">
    <div class="title-section">
      <h1 class="title">
        {{ title }}
        <span *ngFor="let icon of icons">
          <img [src]="icon.src" [alt]="icon.alt">
        </span>
      </h1>
      <p class="subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    
    <!-- ヘッダーアクション（必要に応じて表示） -->
    <div class="header-actions" *ngIf="actions">
      <ng-content select="[slot=actions]"></ng-content>
    </div>
  </div>
</div>